export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fde3c8dd7c96e37463da0173696b1916e040761ec&name=fetchTypeahead!'